<template>
  <div>
    <b-card title="Vielen Dank für Ihre Registrierung!">
      <p>
        Wir haben eine Email an {{ registration.email }} gesendet. Bitte bestätigen Sie Ihre
        Email Adresse durch Anklicken des darin enthaltenen Link.
      </p>

      <p>
        <router-link :to="{name: 'root'}">Zurück zur Startseite</router-link>
      </p>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'RegistrationConfirmation',
  props: ['registration']
}
</script>


// WEBPACK FOOTER //
// src/views/guests/registration/Confirmation.vue